import Http from "../../http/client";
import { RequestQueryBuilder } from "@nestjsx/crud-request";

export default async (tripId) => {
  const qb = RequestQueryBuilder.create();

  qb.setJoin({field: 'user', select: ['id', 'name', 'surname', 'phoneNumber']});
  qb.setJoin({field: 'driver', select: ['id', 'name', 'surname', 'phoneNumber']});
  qb.setJoin({field: 'category', select: ['name']});
  qb.setJoin({field: 'level', select: ['name']});
  qb.setJoin({field: 'city', select: ['name']});
  qb.setJoin({field: 'payment'});
  qb.setJoin({field: 'payment.card'});
  qb.setJoin({field: 'tolls'});
  qb.setJoin({field: 'tolls.toll', select: ['id', 'name']});
  qb.setJoin({field: 'feedbacks'});
  qb.setJoin({field: 'waypoint'});
  qb.setJoin({field: 'vehicle'});
  qb.setJoin({field: 'vehicle.model'});
  qb.setJoin({field: 'manufacturer'});
  qb.setJoin({field: 'actions'});
  qb.setJoin({field: 'actions.user'});

  const response = await Http.get('admin/trips/'+tripId, {
    params: qb.queryObject
  });

  return response.data;
}
